import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ProgramariBlocareService } from '../programari-blocare.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { ProgramareSloturiBlocareUpdate } from '../programari-blocare.interface';
import { GhiseuModuleService } from '../../ghiseu-module/ghiseu-module.service';
import { LocatiiService } from '../../locatii/locatii.service';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';
import { ServiciiService } from '../../servicii/servicii.service';

@Component({
    selector: 'app-edit-programari-blocare',
    templateUrl: './edit-programari-blocare.component.html',
    styleUrls: ['./edit-programari-blocare.component.scss']
})
export class EditProgramariBlocareComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    module!: any[];
    locatii!: any[];
    servicii!: any[];

    form: FormGroup = new FormGroup({
        id_modul: new FormControl(this.data.id_modul, [Validators.required, notDefaultValidator('-1')]),
        id_locatie: new FormControl(this.data.id_locatie, [Validators.required, notDefaultValidator('-1')]),
        id_serviciu: new FormControl(this.data.id_serviciu, [Validators.required, notDefaultValidator('-1')]),
        date_from: new FormControl(this.data.date_from, [Validators.required]),
        time_from: new FormControl(this.data.time_from, [Validators.required]),
        date_end: new FormControl(this.data.date_end, [Validators.required]),
        time_end: new FormControl(this.data.time_end, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditProgramariBlocareComponent>,
        private programariSloturiBlocareService: ProgramariBlocareService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private ghiseuModuleService: GhiseuModuleService,
        private locatiiService: LocatiiService,
        private serviciiService: ServiciiService
    ) {
        this.processToken();
    }

    ngOnInit(): void {
        this.loadModule();
        this.loadLocatii();
        this.loadServicii();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.programariSloturiBlocareService.setToken(token);
        });
    }

    loadModule() {
        this.isLoading = true;
        this.ghiseuModuleService.getModule().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.module = res;
            },
            error: (err) => {
                console.error('Error in get ghiseu module: ', err);
            }
        })
    }

    loadLocatii() {
        this.isLoading = true;
        this.locatiiService.getLocatii().pipe(
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.locatii = res;
            },
            error: (err) => {
                console.error('Error in get locatii: ', err);
            }
        })
    }

    loadServicii() {
        this.isLoading = true;
        this.serviciiService.getServicii().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.servicii = res;
            },
            error: (err) => {
                console.error('Error in get servicii: ', err);
            }
        })
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    submitForm() {
        this.isLoading = true;

        const { id_modul, id_locatie, id_serviciu, date_from, date_end, time_from, time_end } = this.form.value as any;

        const updatedProgramareSloturiBlocare: ProgramareSloturiBlocareUpdate = {
            id_modul,
            id_locatie,
            id_serviciu,
            date_from: date_from ? this.formatDate(date_from) : '',
            date_end: date_end ? this.formatDate(date_end) : '',
            time_from,
            time_end,
            id: this.data.id,
        };

        this.programariSloturiBlocareService
            .updateProgramareSloturiBlocare(updatedProgramareSloturiBlocare)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
